import { render, staticRenderFns } from "./CardEntityMetadata.vue?vue&type=template&id=95d146dc"
import script from "./CardEntityMetadata.vue?vue&type=script&lang=ts"
export * from "./CardEntityMetadata.vue?vue&type=script&lang=ts"
import style0 from "./CardEntityMetadata.vue?vue&type=style&index=0&id=95d146dc&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95d146dc')) {
      api.createRecord('95d146dc', component.options)
    } else {
      api.reload('95d146dc', component.options)
    }
    module.hot.accept("./CardEntityMetadata.vue?vue&type=template&id=95d146dc", function () {
      api.rerender('95d146dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardEntityMetadata.vue"
export default component.exports